import angular from "angular";
angular
  .module("clientDashboardApp.common")
  .directive("newNote", function NewNote() {
    return {
      restrict: "A",
      template:
        "<i class='fas fa-pencil clickable' ng-click='newNote()' uib-tooltip='Add a note for this {{noteSettings.noteType}}.' tooltip-append-to-body='true' tooltip-placement='auto top'></i>",
      scope: {
        rowItem: "=",
        noteSettings: "=",
      },
      controller: function NewNoteController($scope, noteService) {
        $scope.newNote = function () {
          noteService.initNewNote($scope.rowItem, $scope.noteSettings.noteType);
          $scope.noteSettings.newNoteItem = $scope.rowItem;
          $scope.noteSettings.newNote = true;
          $scope.rowItem.newNote = true;
        };
      },
    };
  });
